import { useMemo } from 'react';
import { VideoSize } from 'types';

import { getVideoData, useVideoSize } from 'utils/video';

import { VideoPlayerContainer, VideoPlayerIframe } from './VideoPlayer.styled';
import { VideoPlayerOptions } from './VideoPlayerOptions';
import { getVimeoVideoSrc, getYoutubeVideoSrc } from './helpers';

type Props = {
  url: string;
  size: VideoSize;
  autoPlay?: boolean;
  qaId?: string;
  options?: VideoPlayerOptions;
};

export function VideoPlayer({ url, size, autoPlay, qaId, options }: Props) {
  const { width, height } = useVideoSize(size);

  const videoData = useMemo(() => getVideoData({ url }), [url]);

  const src: string | undefined = useMemo(() => {
    switch (videoData?.type) {
      case 'youtube':
        return getYoutubeVideoSrc({
          videoId: videoData.videoId,
          autoPlay,
          showRelatedVideos: options?.showYoutubeRelatedVideos,
        });
      case 'vimeo':
        return getVimeoVideoSrc({ videoId: videoData.videoId, autoPlay });
    }

    return undefined;
  }, [
    autoPlay,
    options?.showYoutubeRelatedVideos,
    videoData?.type,
    videoData?.videoId,
  ]);

  return (
    <VideoPlayerContainer style={{ width, height }}>
      {videoData && src ? (
        <VideoPlayerIframe
          title="video"
          src={src}
          allowFullScreen
          allow="autoplay; fullscreen"
          data-qa-id={qaId}
          $videoDataType={videoData.type}
        />
      ) : (
        <>Invalid video url</>
      )}
    </VideoPlayerContainer>
  );
}
